module.exports = __webpack_public_path__ + "static/media/freight.1cdb2e7a.jpg";